import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import { useLookupsStore } from '@/stores/lookups'

/**
 * Checks if the IBAN number matches the selected refund bank.
 */
const checkIbanIfMatchingRefundBanks = (actionParams) => {
  const formStore = useFormStore()
  const lookupStore = useLookupsStore()

  const ibanNumber = formStore.form.values.iban
  const ibanCodePrefix = ibanNumber.substring(2, 5)
  const matchingBank =
    lookupStore.optionSourceMap[actionParams.path]?.find((bank) => {
      return bank.ibanCode == ibanCodePrefix
    }) || {}

  formStore.form.setValues({
    bankName: matchingBank.text || '',
    swiftCode: matchingBank.swiftCode || '',
    bankNameID: matchingBank.value || '',
    bankInfoFound: matchingBank ? true : false
  })
}
/**
 * Checks if the Request number is available.
 */
const checkValidEidaRequest = async () => {
  const formStore = useFormStore()
  const requestNumber = formStore.form.values.referenceRequestNumber
  const params = {
    requestNumber
  }

  if (requestNumber) {
    const res = apiHelperService.get('/api/icaRequest/checkValidEidaRequestForRefund', {
      params
    })
  }
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'checkIbanIfMatchingRefundBanks':
      checkIbanIfMatchingRefundBanks(actionParams)
    case 'checkValidEidaRequest':
      checkValidEidaRequest(actionParams)
      break
    default:
      break
  }
}
